import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n.js";
import { ContextProvider } from "./context/ContextProvider.js";
import Store from "./redux/store.js";
import { Provider } from "react-redux";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration.js";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  {" "}
  <ContextProvider>
  <Provider store={Store}>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </Provider>
</ContextProvider>
</React.StrictMode>
);

serviceWorkerRegistration.register();
reportWebVitals();
